// Vendor Libs
import React from 'react'; // Material UI

import { makeStyles } from '@material-ui/core/styles';
import { LinearProgress } from '@material-ui/core';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      color: '#20557b',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      '& > * + *': {
        marginLeft: theme.spacing(2)
      }
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    logo: {
      height: '120px',
      marginBottom: '2em'
    },
    colorPrimary: {
      backgroundColor: '#b3d0e6'
    },
    barColorPrimary: {
      backgroundColor: '#20557b'
    }
  };
});
export var AuthLoading = function AuthLoading(_ref) {
  var img = _ref.img;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.loading
  }, /*#__PURE__*/React.createElement("img", {
    alt: "ripple logo",
    className: classes.logo,
    src: img
  }), /*#__PURE__*/React.createElement(LinearProgress, {
    classes: {
      colorPrimary: classes.colorPrimary,
      barColorPrimary: classes.barColorPrimary
    },
    style: {
      width: '92%'
    }
  })));
};